import { render, staticRenderFns } from "./index.vue?vue&type=template&id=04071b28&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04071b28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04071b28')) {
      api.createRecord('04071b28', component.options)
    } else {
      api.reload('04071b28', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=04071b28&scoped=true", function () {
      api.rerender('04071b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/rightBtn/index.vue"
export default component.exports